<nav class="nav program-navbar fixed-top">
	<dev-banner></dev-banner>

	<!-- Logo -->

	<button class='search-btn' mat-button routerLink="/" title='Home' style='margin-left:15px;margin-right:5px;'>
		<img src='assets/logo/eforall_96x30.png' style='position: relative; top: -1px;' alt="EforAll">
	</button>

	<!-- App name -->
	<div class="app-name me-3">{{frameService.config().appName}}</div>


	<!-- Hamburger Menu Toggle -->

	<button class='search-btn' mat-button (click)="menu.toggleCollapsed()" title='Toggle Menu'>
		<i class='fa-regular fa-bars transition'></i>
	</button>


	<!-- Any additional content can be placed here -->
	<ng-content></ng-content>

	<button class='search-btn sign-out-btn' mat-button (click)="frameService.config().signOut()" title="Sign Out">
		<common-icon-text iconStyle="fa-regular" icon="fa-fw fa-power-off" text="Sign Out"
			spacing="large"></common-icon-text>
	</button>
</nav>